import React from "react";
import Icon from "@ant-design/icons";
import Icons from "assets/icons";
import {ColumnsEdit} from "types/models/column-table-edit";
import {STATUS_CARD, STATUS_DISCOUNT} from "assets/constants/card-types";

export type DataTableMenu = {
  tenDichVu: string;
  giaTri: number;
  soLan: number;
};
const TRANGTHAITHE = [
  {value: 0, label: "Chưa bán"},
  {value: 1, label: "Đã bán"},
  {value: 2, label: "Đã dùng"},
  {value: 3, label: "Del"},
];
let dataTableMenu: Array<DataTableMenu> = [];

const optionsLieuDung: any = [
  {
    label: "1 lần/ngày",
    value: 0,
  },
  {
    label: "2 lần/ngày",
    value: 1,
  },
  {
    label: "1 lần/ngày",
    value: 2,
  },
  {
    label: "Chọn liều dùng",
    value: -1,
  },
];
const validatePositiveInteger = (_, value) => {
  if (!value || /^[1-9]\d*$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Chưa nhập đúng định dạng!"));
};

const columnsTableMenu = [
  {
    title: "STT",
    key: "stt",
    align: "center",
    render: (v, r, i) => i + 1,
    width: "2%",
  },
  {
    title: "Mã loại thẻ",
    dataIndex: "ma",
    key: "tenDichVu",
    // editable: true,
    // type: "AUTO_COMPLETE",
  },
  {
    title: "Tên loại thẻ",
    dataIndex: "tenLoaiThe",
    // editable: true,
    // type: "INPUT",
    // rules: [{validator: validatePositiveInteger}],
  },
  {
    title: "Trạng thái",
    dataIndex: "trangThai",
    align: "left",
    width: "8%",
    render: (v, r, i) => {
      if (r.loai === 0) {
        return STATUS_CARD.find(it => it.value === v)?.label || "";
      } else return STATUS_DISCOUNT.find(it => it.value === v)?.label || "";
    },
  },
  {
    title: "Số lượng",
    dataIndex: "soLuong",
    editable: true,
    type: "INPUT",
    align: "right",
    width: "8%",
    rules: [
      {required: true, message: "Số lượng là bắt buộc"},
      {validator: validatePositiveInteger},
    ],
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    width: "8%",
  },
];

export {columnsTableMenu, dataTableMenu, optionsLieuDung};
